import type * as openapi from '@/helpers/api/types/openapiOverrides';

export async function readFileAsDataURL(file: File): Promise<string> {
  return await new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => {
      resolve(fr.result as string);
    };
    fr.onerror = reject;
    fr.readAsDataURL(file);
  });
}

// Zammad requires base64 encoding for files
export async function getBase64FileForZammad(
  file: File,
): Promise<Required<openapi.ZammadArticleOpenapi>['attachments'][0]> {
  return {
    data: (await readFileAsDataURL(file)).replace(/^data:.+;base64,/, ''),
    filename: file.name,
    'mime-type': file.type,
  };
}
